import(/* webpackMode: "eager", webpackExports: ["BenefitsContent"] */ "/vercel/path0/src/app/benefits/BenefitsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTA"] */ "/vercel/path0/src/sections/CTA.tsx");
